//For Item only -this function is helpful
import _ from 'lodash';

import { showErrorToast } from '../components/Toast';
import { Routes } from '../routes';
import apiService from '../service/ApiService';
import { setCustomization } from '../store/slices/lookupSlice';
import { CustomizatonType } from '../types/CustomizatonType';
import Enums from '../helpers/enums';

export async function getCustomizeItems({ item, siteId, isDelivery, dispatch, itemCustomizations, navigate, isMandatoryCustomization, showSkip, isUpdateCart }: CustomizatonType) {
    const foundItemCustomization = _.find(itemCustomizations, { 'salesItemId': item.type === Enums.comboType.quickCombo ? item.items?.[0]?.salesItemId : item.salesItemId });
    if (foundItemCustomization && foundItemCustomization.customizations.length > 0) {
        item = {
            ...item,
            allCustomizations: foundItemCustomization.customizations,
        };

        if (item.type === Enums.comboType.quickCombo) {
            navigate(Routes.CustomizeItemForMealOnly, { state: { categoryItem: item, isMandatory: isMandatoryCustomization, showSkip: showSkip, isUpdateCart: isUpdateCart } });
        } else {
            navigate(Routes.CustomizeItemForItemOnly, { state: { categoryItem: item, isMandatory: isMandatoryCustomization, showSkip: showSkip, isUpdateCart: isUpdateCart } });
        }
    } else {
        const { data } = item.menuId ? await apiService.getOrderkeyCustomizationsAsync(
            siteId,
            item.type === Enums.comboType.quickCombo
                ? item?.items?.[0]?.posItemId ?? 0
                : item.posItemId,
            item.menuId,
            isDelivery
        )
            : await apiService.getCustomizeItemsAsync(
                siteId,
                item.type === Enums.comboType.quickCombo
                    ? item?.items?.[0]?.salesItemId ?? 0
                    : item.salesItemId,
                isDelivery
            );

        if (data && data.length > 0) {
            const customizations = _.map(data, (cItem) => {
                cItem.quantity = cItem.canRemove === 1 ? 1 : 0;
                cItem.defaultQuantity = cItem.canRemove === 1 ? 1 : 0;
                cItem.isDefaultItem = cItem.canRemove === 1;
                cItem.modCodeId = -1;
                return cItem;
            });
            dispatch(setCustomization([{
                salesItemId: item.salesItemId,
                customizations
            }]));
            const updatedItem = {
                ...item,
                allCustomizations: customizations
            };
            if (item.type === Enums.comboType.quickCombo) {
                navigate(Routes.CustomizeItemForMealOnly, { state: { categoryItem: updatedItem, isMandatory: isMandatoryCustomization, showSkip: showSkip, isUpdateCart: isUpdateCart } });
            } else {
                navigate(Routes.CustomizeItemForItemOnly, { state: { categoryItem: updatedItem, isMandatory: isMandatoryCustomization, showSkip: showSkip, isUpdateCart: isUpdateCart } });
            }
        } else {
            dispatch(setCustomization([{ salesItemId: item.salesItemId, customizations: [] }]));
            showErrorToast('No customisations available for this item');
        }
    }
}